var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', _vm._l(_vm.brochures, function (_ref) {
    var _id = _ref._id,
        url = _ref.url,
        fileName = _ref.fileName;
    return _c('v-chip', {
      key: _id,
      staticClass: "rounded-0",
      attrs: {
        "href": url,
        "download": "",
        "color": "primary",
        "outlined": ""
      }
    }, [_vm._v(_vm._s(fileName))]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }